/** Resolve only IDs still present in the available playground catalogues. */
export function resolveActiveCatalogueId(
  catalogues: ReadonlyArray<{ id: string }>,
  selectedId?: string,
): string | undefined {
  return catalogues.some(catalogue => catalogue.id === selectedId) ? selectedId : catalogues[0]?.id;
}
